// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__7sns3","title":"BackImages_title__22YqD","images":"BackImages_images__1LEzk"};